import { createSelector } from 'reselect';

const getRoutes = (state) => state.unplannedRoutes.data;
const getBranchNumber = (state, branchNumber) => branchNumber;

export const getUnplannedRoutesForBranche = createSelector(
    [ getRoutes, getBranchNumber ],
    (route_data, branchNumber) => {
        
        const routes = Object.values(route_data).filter(({ branch_nummer }) => { 
            return branch_nummer === branchNumber
        });

        routes.sort((a, b) => (a.licenseplate || '').localeCompare(b.licenseplate || ''));

        //const routeIds = routes.map(route => route.documentId)
        
        return routes;
    }
);
